<template>
  <div class="news-detail" id="news-detail">
    <div class="caption clear-float">
      <span class="title">{{ $t('news_detail') }}</span>
      <router-link class="return-btn red lighter icon-arrow-left" tag="span" :to="{ name: 'newsListLink', query: { search: this.$route.query.search, currentPage: this.$route.query.currentPage } }">{{ $t('return_to_news_list') }}</router-link>
    </div>
    <div class="detail lighter" v-if="news && news[lang]">
      <div class="title bold">{{ news[lang] ? news[lang].title : '' }}</div>
      <div class="date">{{ news.date.split('T')[0] }}</div>
      <div class="abstract regular" v-if="news[lang].abstract && news[lang].abstract.length > 0">
        <li v-for="(item, index) in news[lang] ? news[lang].abstract.split('\n') : []" class="content-item" :key="'content-item-' + index">
          <span>{{ item }}</span>
        </li>
      </div>
      <a :href="news.refUrl" class="source" v-if="news.refUrl" target="_blank">{{ news.urlTitle }}</a>
      <ul class="content-list">
        <!--p v-html="news[lang]?news[lang].content:''"></p-->
        <li v-for="(item, index) in news[lang] ? news[lang].content.split('\n') : []" class="content-item" :key="'content-item-' + index">
          <span v-if="!item.startsWith('/static', 0) && !item.startsWith('##', 0)">{{ item }}</span>
          <span v-if="item.startsWith('##B', 0)">
            <b>{{ item.replace('##B', '') }}</b>
          </span>
          <span v-if="item.startsWith('##R', 0)">
            <b class="red-T">{{ item.replace('##R', '') }}</b>
          </span>
          <span v-if="item.startsWith('##T', 0)">&nbsp;&nbsp;&nbsp;&nbsp;{{ item.replace('##T', '') }}</span>
          <span v-if="item.startsWith('##L', 0)">
            <a target="_blank" :href="item.replace('##L', '')">{{ item.replace('##L', '') }}</a>
          </span>
          <span v-if="item.startsWith('##html', 0)"><div class="html-detail ck-content" v-html="item.replace('##html', '')"></div></span>
          <img align="center" v-if="item.startsWith('/static', 0)" :src="item" alt="" class="news-img img" />
        </li>
      </ul>
      <ul class="img-list">
        <li v-for="(item, index) in news.imgUrl" class="img-item" :key="'img-' + index">
          <img :src="item" alt="" class="news-img img" />
        </li>
      </ul>
      <!-- <div class="notes-to-editors bold">
                <span class="tip">{{'NOTES TO EDITORS'}}</span>
                <span class="split-line"></span>
            </div>
            <ul class="notes-list">
                <li v-for="(note, index) in news.notes" class="note-item" :key="'note-item-'+index">
                    <div class="name bold red">{{note.name}}</div>
                    <p class="dec">{{note.dec}}</p>
                </li>
            </ul> -->
    </div>
  </div>
</template>

<script>
import '@/assets/css/ckeditor5.css'
import API from '../../api/api'

export default {
  name: 'NewsDetail',
  data() {
    return {
      newsId: this.$route.query.id,
      news: null
    }
  },
  computed: {
    lang() {
      return this.$store.getters.getLang
    },

    newsList() {
      return this.$store.getters.getNewsList
    }
  },
  watch: {
    lang() {
      if (this.lang == 'en' && this.news.chOnly == true) {
        this.$router.push({ name: 'newsListLink' })
      }
    }
  },
  created() {
    this.newsId = this.$route.query.id
    this.getNewsById()
  },
  methods: {
    getNewsById() {
      API.getNewsById(this.newsId).then(res => {
        const temp = {
          id: res.id,
          chOnly: res.chOnly,
          date: res.date,
          imgUrl: res.imgUrl ? res.imgUrl.split(';') : null,
          refUrl: res.refUrl,
          urlTitle: '',
          status: res.status,
          zh: { title: res.title, abstract: res.summary, content: res.content },
          en: { title: res.eTitle, abstract: res.eSummary, content: res.eContent }
        }
        this.news = temp
      })
    }
  }
}
</script>

<style lang="less" scoped>
.news-detail {
  img {
    text-align: center;
  }
  a {
    color: rgba(202, 17, 58, 1);
    text-decoration: underline;
  }
  // border: 1px solid red;
  .caption {
    span {
      float: left;
      display: inline-block;
      // border: 1px solid red;
    }
    .return-btn {
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      font-size: 14px;
      margin-left: 30px;
      &::before {
        transition: margin ease-in-out 0.45s;
        margin-right: 10px;
      }
      &:hover {
        &::before {
          margin-right: 16px;
        }
      }
    }
  }

  #news-detail > span > div > table,
  th,
  td {
    border: 1px solid black;
    border-collapse: collapse;
  }

  #news-detail > span > div > table > tbody > tr > td {
    padding: 5px;
  }

  .detail {
    font-size: 16px;
    line-height: 30px;
    padding: 0px 30px;
    box-sizing: border-box;
    // border: 1px solid red;
    .title,
    .source,
    .content-list,
    .img-list,
    .notes-to-editors,
    .notes-list {
      margin: 30px;
    }
    // 标题
    .title {
      font-size: 24px;
      width: 80%;
      line-height: 36px;
      margin: 0 auto;
      text-align: center;
      box-sizing: border-box;
      // border: 1px solid red;
    }
    // 日期
    .date {
      text-align: center;
      width: 220px;
      height: 30px;
      line-height: 30px;
      margin: 20px auto 30px;
      border: 2px solid #f3f3f3;
    }
    // 摘要
    .abstract {
      padding: 30px;
      box-sizing: border-box;
      background-color: #f3f3f3;
    }
    // 新闻出处
    .source {
      cursor: pointer;
      display: block;
      font-size: 14px;
      padding-left: 15px;
      box-sizing: border-box;
      border-left: 5px solid rgba(202, 17, 58, 1);
      &:hover {
        color: rgba(202, 17, 58, 1);
      }
    }
    // 正文
    .content-list {
      .content-item {
        margin-top: 10px;
        .news-img {
          margin-top: 15px;
          max-width: 100%;
          max-height: 500px;
          display: block;
          margin-left: auto;
          margin-right: auto;
        }
        .html-detail {
          /deep/ ul ul ul li {
            list-style-type: square;
          }
          /deep/ ul ul li {
            list-style-type: circle;
          }
          /deep/ ul li {
            list-style-type: disc;
          }
          /deep/ ul,
          /deep/ ol {
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            padding-inline-start: 40px;
            unicode-bidi: isolate;
          }
          /deep/ blockquote {
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
          }
        }
      }

      .red-T {
        color: rgba(202, 17, 58, 1);
      }
    }
    // 图片
    .img-list {
      // border: 1px solid greenyellow;
      .img-item {
        text-align: center;
        margin-top: 15px;
        .news-img {
          max-width: 100%;
          max-height: 500px;
        }
      }
    }
    .notes-to-editors {
      font-size: 16px;
      height: 30px;
      line-height: 30px;
      margin: 40px 30px;
      // border: 1px solid red;
      display: flex;
      span {
        display: inline-block;
        vertical-align: middle;
        // border: 1px solid red;
      }
      .tip {
        padding-right: 15px;
      }
      .split-line {
        flex: 1;
        height: 1px;
        margin: auto 0;
        background-color: #f6f6f6;
        // border: 1px solid red;
      }
    }
    // 解析说明
    .otes-listn {
      .note-item {
        margin-top: 40px;
        .name {
          margin-bottom: 15px;
          font-size: 18px;
        }
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .news-detail {
    .caption {
      position: relative;
      .return-btn {
        height: 20px;
        line-height: 20px;
        margin: 0;
        position: absolute;
        left: 0;
        bottom: -30px;
      }
    }
    .detail {
      .title,
      .source,
      .content-list,
      .img-list,
      .notes-to-editors,
      .notes-list {
        margin: 30px 15px;
      }
      .title {
        // text-align: left;
        // border: 1px solid red;
        font-size: 20px;
        line-height: 30px;
        margin: 0 auto;
      }
      .date {
        margin: 20px auto 30px;
      }
    }
  }
}
@media screen and (max-width: 550px) {
  .news-detail {
    .detail {
      padding-left: 15px;
      padding-right: 15px;
      .title {
        font-size: 18px;
      }
      .abstract {
        padding: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news/Detail.vue